import { z } from 'zod';

/** `*` only at the end of the local part; the domain is required. */
const ENTRY = /^[^@\s*]*\*?@[^@\s*]+\.[^@\s*]+$/;

/**
 * Addresses no one reads, added to the built-in rules of `isSyntheticEmail`
 * without a code change. Comma-separated entries, each on one domain:
 * - an exact address: `sales.demo1@cntxt.com`
 * - a prefix, ending in `*`: `sales_demo_*@cntxt.com`
 * - a whole domain: `@partner-sandbox.com`
 *
 * It can only stop email, never allow it. A malformed entry fails startup
 * rather than being silently ignored.
 *
 * Validated, not transformed: `env` hands over the raw string wherever the
 * schema doesn't run (validation skipped, a jsdom test), so the value keeps
 * one shape everywhere and `isSyntheticEmail` splits it itself.
 */
export const syntheticEmails = z
  .string()
  .optional()
  .refine(
    (value) =>
      (value ?? '')
        .split(',')
        .map((entry) => entry.trim())
        .filter(Boolean)
        .every((entry) => ENTRY.test(entry)),
    'Each SYNTHETIC_EMAILS entry is an address, a prefix* @domain, or an @domain',
  );
